import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { getResetByTag, utilityStyles, rem } from './../../../styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("position:relative;margin-bottom:", rem(10), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var positioningStyles = function positioningStyles(_ref) {
  var size = _ref.size,
    inline = _ref.inline;
  var bottoms = {
    '2xs': {
      "default": 0,
      mobile: 0
    },
    xs: {
      "default": 1,
      mobile: 1
    },
    sm: {
      "default": 2,
      mobile: 1
    },
    md: {
      "default": 4,
      mobile: 2
    },
    lg: {
      "default": 5,
      mobile: 4
    },
    xl: {
      "default": 6,
      mobile: 6
    },
    '2xl': {
      "default": 9,
      mobile: 7
    },
    '3xl': {
      "default": 8,
      mobile: 7
    },
    '4xl': {
      "default": 14,
      mobile: 10
    },
    '5xl': {
      "default": 18,
      mobile: 8
    },
    "default": {
      "default": 18,
      mobile: 10
    }
  };
  if (!inline) {
    var bottom = bottoms[size] || bottoms["default"];
    return /*#__PURE__*/css("bottom:", rem(bottom["default"]), ";@media (max-width: 768px){bottom:", rem(bottom.mobile), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:positioningStyles;"));
  }
};
var inlinePositioning = function inlinePositioning(_ref2) {
  var size = _ref2.size,
    inline = _ref2.inline;
  if (inline && size) {
    return /*#__PURE__*/css("top:", rem(0), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:inlinePositioning;"));
  }
};
var resetStyles = getResetByTag('span');
var StyledPriceFractional = /*#__PURE__*/_styled('span', process.env.NODE_ENV === "production" ? {
  target: "e1p18ggn0"
} : {
  target: "e1p18ggn0",
  label: "StyledPriceFractional"
})(resetStyles, positioningStyles, inlinePositioning, defaultStyles, utilityStyles);
export default StyledPriceFractional;